import { Table, Typography } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import { useMemo } from 'react'
import { ZoneSummaryQuery_zone_Zone } from '~/gql/generated/graphql'

const columns: ColumnsType<any> = [
  {
    title: 'Vehicle Type',
    dataIndex: 'vehicle',
  },
  {
    title: 'Hireable',
    dataIndex: 'hireable',
  },
  {
    title: 'Non-hireable',
    dataIndex: 'non_hireable',
  },
]
const ZoneContents = ({ zone }: { zone: ZoneSummaryQuery_zone_Zone }) => {
  const dataSource = useMemo(
    () => [
      {
        vehicle: 'Bikes',
        // `bikes` includes e-bikes. The queries alias it to
        // `all_commissioned_vehicles_count(propulsion_type: human)`, which reads as
        // pedal-only, but e-bikes are stored with propulsion [human, electric_assist]
        hireable: (zone?.hireable_bikes ?? 0) - (zone?.hireable_ebikes ?? 0),
        non_hireable:
          (zone?.bikes ?? 0) -
          (zone?.ebikes ?? 0) -
          (zone?.hireable_bikes ?? 0) +
          (zone?.hireable_ebikes ?? 0),
      },
      {
        vehicle: 'e-Bikes',
        hireable: zone?.hireable_ebikes,
        non_hireable: (zone?.ebikes ?? 0) - (zone?.hireable_ebikes ?? 0),
      },
      {
        vehicle: 'e-Scooters',
        hireable: zone?.hireable_scooters,
        non_hireable: (zone?.scooters ?? 0) - (zone?.hireable_scooters ?? 0),
      },
    ],
    [
      zone.bikes,
      zone.hireable_bikes,
      zone.ebikes,
      zone.hireable_ebikes,
      zone.scooters,
      zone.hireable_scooters,
    ],
  )
  return (
    <Table
      bordered={false}
      dataSource={dataSource}
      columns={columns}
      size="small"
      summary={() => (
        <Table.Summary>
          <Table.Summary.Row>
            <Table.Summary.Cell index={0}>
              <Typography.Text strong>Total</Typography.Text>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={1}>
              <Typography.Text strong>
                {zone?.hireable_vehicles_count}
              </Typography.Text>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={2}>
              <Typography.Text strong>
                {zone?.all_commissioned_modules_count -
                  zone?.hireable_vehicles_count}
              </Typography.Text>
            </Table.Summary.Cell>
          </Table.Summary.Row>
        </Table.Summary>
      )}
      pagination={{ pageSize: 50, hideOnSinglePage: true }}
    />
  )
}

export default ZoneContents
